import { Item, ItemType } from '@inno-sdks/files'
import { AppId } from '@inno-tools/container-bridge'
import { NEED_HELP_SHORTCUT_ITEM_SIZE } from 'modules/desktop/constants'

import type { SystemShortcutConfig } from './systemShortcut.types'

const SUPPORT_MODAL = 'support'
const SUPPORT_SOURCE = 'shortcut'

const isSupportDeepLink = (value: string): boolean => {
  try {
    const url = new URL(value, window.location.origin)

    return (
      url.searchParams.get('modal') === SUPPORT_MODAL &&
      url.searchParams.get('source') === SUPPORT_SOURCE
    )
  } catch {
    return false
  }
}

export const NEED_HELP_SHORTCUT = {
  key: 'need-help',
  name: 'Need Help?',
  shortcutUrl: `${process.env.REACT_APP_DOMAIN}/?modal=support&source=shortcut`,
  displayNameKey: 'need_help',
  iconAppId: AppId.LIVE_CHAT,
  action: 'openSupport',
  requiresLoadingState: true,
  deepLink: {
    matches: isSupportDeepLink,
    consumedSearchParams: ['modal', 'source']
  },
  presentation: {
    itemType: 'shortcut',
    label: 'Need Help?',
    iconType: 'image',
    icon: '/app-icons/messenger.webp',
    visualStyle: 'featured',
    isPinned: true,
    isPermanent: true,
    position: { row: 0, col: 0 },
    size: NEED_HELP_SHORTCUT_ITEM_SIZE,
    onClick: {
      type: 'openUrl',
      url: `${process.env.REACT_APP_DOMAIN}/?modal=support&source=shortcut`
    }
  }
} satisfies SystemShortcutConfig

/** Ignores origin so matching survives a different REACT_APP_DOMAIN per environment. */
const normalizeUrl = (value: string): string => {
  try {
    return new URL(value, window.location.origin).pathname
  } catch {
    return value
  }
}

/** Identifies the provisioned system shortcut without relying on its file id. */
export const isNeedHelpShortcut = (item: Item): boolean =>
  item.type === ItemType.Shortcut &&
  item.name === NEED_HELP_SHORTCUT.name &&
  item.extra?.isPermanent === true &&
  normalizeUrl(item.metaData.shortcutUrl) ===
    normalizeUrl(NEED_HELP_SHORTCUT.shortcutUrl)
